import { useMutation } from 'react-query';
import { resetPassword } from '../../../store/apiCalls/authentication';

function OnPasswordReset(sucessHandler,error,setError) {
    return {
        ...useMutation(resetPassword, {
            onSuccess: (data) => { sucessHandler(data)
            setError({...error,apiError:''})
            },
            onError: (errMsg) => {
                setError({...error,apiError:errMsg.response.data.message||'Something went wrong, Please try again after sometime'})
            },
        })
    }
}


export {
    OnPasswordReset,
}